export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Magasins à relancer"])},
        "days_without_sale": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("count")), " j sans vente"])},
        "no_sale": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucune vente"])},
        "estompe_detail": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("recent")), " ventes / 10j (vs ", _interpolate(_named("previous")), " avant)"])},
        "empty_state": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tous vos magasins sont actifs, bravo !"])},
        "signal": {
          "SILENT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SILENCIEUX"])},
          "DROPPED": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DÉCROCHÉ"])},
          "FADING": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ESTOMPÉ"])},
          "NEVER_ACTIVE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JAMAIS ACTIF"])}
        }
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stores to relaunch"])},
        "days_without_sale": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("count")), " d without sale"])},
        "no_sale": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No sale"])},
        "estompe_detail": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("recent")), " sales / 10d (vs ", _interpolate(_named("previous")), " before)"])},
        "empty_state": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All your stores are active, well done!"])},
        "signal": {
          "SILENT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SILENT"])},
          "DROPPED": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DROPPED"])},
          "FADING": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FADING"])},
          "NEVER_ACTIVE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["NEVER ACTIVE"])}
        }
      }
    }
  })
}
